export default __webpack_public_path__ + "static/media/produtividade.9a293fd9.png";